import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    appendLoaderTo: String,
    appendLoaderTemplateSelector: String,
    formSubmitClasses: String,
  }

  connect() {
    this.connectClearableInputs()
  }

  connectClearableInputs() {
    this.element.querySelectorAll(".clearable-input").forEach(input => {
      const clearButton = input.nextElementSibling

      // on blur, submit form if field is blank
      input.addEventListener("blur", () => {
        if (input.value === "") {
          input.form.requestSubmit()
        }
      }
      )
    })
  }

  appendLoader() {
    if (this.appendLoaderTemplateSelectorValue) {
      const template = document.querySelector(this.appendLoaderTemplateSelectorValue)
      const loader = template.content.cloneNode(true)

      const target = document.querySelector(this.appendLoaderToValue)
      target.appendChild(loader)
      target.lastElementChild?.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  onSubmit(event) {
    // Check if any submit button is already disabled
    const anyButtonAlreadyDisabled = Array.from(this.submitButtons()).some(button => button.disabled);
    
    if (anyButtonAlreadyDisabled) {
      // Prevent form submission if any button is already disabled
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
    
    this.appendLoader()

    if (this.formSubmitClassesValue) {
      // apply classes to form ele
      this.element.classList.add(...this.formSubmitClassesValue.split(" "))
    }

    this.submitButtons().forEach(button => {
      button.disabled = true
    })
  }

  submitButtons() {
    return this.element.querySelectorAll("input[type='submit']")
  }

  destroyNested(e) {
    e.preventDefault()
    const wrapper = e.target.closest(".nested-wrapper")
    // hide and the mark _destroy field as true
    wrapper.style.display = "none"
    wrapper.querySelector("input[name*='_destroy']").value = 1
    
    // Remove required attribute from all input fields in the wrapper
    wrapper.querySelectorAll('input, select, textarea').forEach(field => {
      if (field.hasAttribute('required')) {
        field.removeAttribute('required')
      }
    })
  }

  removeNested(e) {
    e.preventDefault()
    const wrapper = e.target.closest(".nested-wrapper")
    wrapper.remove()
  }
}
